import { Injectable } from '@angular/core';
import { IAuthenticationService } from '@pershing/pershing-core';

@Injectable()
export class NxiAuthenticationService implements IAuthenticationService {
    authenticate(userId: string, password: string): any { }
    getToken(): string { return ''; }
    getCookie(): string { return ''; }
    isLoggedIn(): boolean { return true; }
    setUserLoggedIn(): void { }
    logout(): void { }
}
